<template>
  <el-form
      :class="['login-form', 'login-form-small', { 'login-form--oauth': isOAuth }]"
      :rules="loginRules"
      ref="loginForm"
      style="padding-right: 10px;"
      size="mini"
      :model="loginForm"
      label-position="right"
      :label-width="formLabelWidth"
  >
    <el-form-item :label="$t('common.emailbox')+':'" prop="username">
      <el-input
          @keyup.enter.native="handleLogin"
          v-model="loginForm.username"
          auto-complete="off"
          :placeholder="$t('40303')"
          @blur="checkTargetEmails"
          :validate-event="false"
      >
      </el-input>
    </el-form-item>
    
    <!-- 密码/授权码字段 - Google 需要显示，Microsoft/Outlook 不需要 -->
    <el-form-item
        v-if="!isOAuth"
        :label="getPasswordLabel()"
        prop="password"
    >
      <el-input
          @keyup.enter.native="handleLogin"
          :type="passwordType"
          show-password
          v-model="loginForm.password"
          auto-complete="off"
          :placeholder="getPasswordPlaceholder()"
          :validate-event="false"
      >
      </el-input>
      <el-button
          v-if="isGoogleOAuth"
          type="text"
          size="small"
          style="margin-top: 5px;"
          @click="openGoogleAppPasswordPage"
      >
        {{ $t('get.app.password') }}
      </el-button> 
    </el-form-item>
    
    <!-- OAuth 模式下只显示别名，不显示服务器配置 -->
    <template v-if="!isOAuth">
      <div class="form-line"></div>
      <el-form-item :label="$t('protocol.type')+':'" prop="acceptProtocol">
        <el-select
            v-model="loginForm.acceptProtocol"
            @change="selectChange"
            :placeholder="$t('protocol.placeholder')"
            style="width: 100%"
            :validate-event="false"
        >
          <el-option
              :label="item.label"
              :value="item.value"
              v-for="(item, index) in mailConfigTypes"
              :key="'mailTypes' + index"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="mail-server-row" :label="$t('pop.server')" prop="acceptHost" v-if="loginForm.acceptProtocol === 'pop3'">
        <el-input
            @keyup.enter.native="handleLogin"
            v-model="loginForm.acceptHost"
            auto-complete="off"
            @input="handleClickInputAcceptHost"
            style="width: 161px; margin-right: 90px"
            :placeholder="$t('placeholder.server')"
        ></el-input>

        <span class="mail-server-row__port-label" style="font-weight: 500">{{ $t('server.port') }}:</span>
        <el-input
            class="mail-server-row__port-input"
            style="width: 68px;margin-right: 10px"
            @keyup.enter.native="handleLogin"
            v-model="loginForm.acceptPort"
            auto-complete="off"
            :placeholder="$t('server.port')"
        ></el-input>
        <el-checkbox
            v-model="loginForm.acceptSsl"
            :true-label="1"
            :false-label="0"
            @change="acceptPOP3SSLChange"
            :disabled="mailAccountType === 'jck'||mailAccountType==='gmail'"
        ><span style="font-weight: 500">SSL</span>
        </el-checkbox>

      </el-form-item>
      <el-form-item
          class="mail-server-row"
          :label="$t('common.imap.server')+':'"
          v-if="loginForm.acceptProtocol === 'imap'"
          prop="acceptProtocol"
      >
        <el-input
            @keyup.enter.native="handleLogin"
            v-model="loginForm.acceptHost"
            auto-complete="off"
            style="width: 161px; margin-right: 90px"
            :placeholder="$t('placeholder.server')"
        ></el-input>
        <span class="mail-server-row__port-label" style="font-weight: 500">{{ $t('server.port') }}:</span>
        <el-input
            class="mail-server-row__port-input"
            @keyup.enter.native="handleLogin"
            v-model="loginForm.acceptPort"
            style="width: 68px;margin-right: 10px"
            @input="onAcceptPortInput($event.target.value)"
            auto-complete="off"
            :placeholder="$t('server.port')"
        ></el-input>
        <el-checkbox
            v-model="loginForm.acceptSsl"
            :true-label="1"
            :false-label="0"
            @change="acceptIMAPSSLChange"
            :disabled="mailAccountType === 'jck'||mailAccountType==='gmail'"
        ><span style="font-weight: 500">SSL</span>
        </el-checkbox>
      </el-form-item>
      <el-form-item class="mail-server-row" :label="$t('common.smtp.server')+':'" prop="sendHost">
        <el-input
            @keyup.enter.native="handleLogin"
            v-model="loginForm.sendHost"
            style="width: 161px; margin-right: 90px"
            auto-complete="off"
            :placeholder="$t('placeholder.server')"
        ></el-input>
        <span class="mail-server-row__port-label" style="font-weight: 500">{{ $t('server.port') }}:</span>
        <el-input
            class="mail-server-row__port-input"
            @keyup.enter.native="handleLogin"
            v-model="loginForm.sendPort"
            @input="onSendPortInput($event.target.value)"
            auto-complete="off"
            style="width: 68px;margin-right: 10px"
            :placeholder="$t('server.port')"
        ></el-input>
        <el-checkbox
            v-model="loginForm.sendSsl"
            :true-label="1"
            :false-label="0"
            @change="sendSMTPSSLChange"
            :disabled="mailAccountType === 'jck' ||mailAccountType==='gmail'"
        ><span style="font-weight: 500">SSL</span>
        </el-checkbox>
      </el-form-item>
    </template>
    
    <el-form-item :label="$t('send.username.email')" prop="remark">
      <el-input
          v-model="loginForm.remark"
          auto-complete="off"
          :placeholder="$t('send.username.placeholder')"
          :validate-event="false"
      >
      </el-input>
    </el-form-item>
  </el-form>
  <div style="border-bottom: 1px solid #f3f3f3; margin-top: 10px;width: 100%"></div>
  <div class="flex_end">
    <ElButton size="small" @click="cancels">
      {{ $t('common.cancel') }}
    </ElButton>
    <ElButton size="small" type="primary" :loading="loading" @click="handleLogin"
    >
      {{ $t('common.confirm') }}
    </ElButton>
  </div>
</template>

<script>
import {setMailConfigList, updateConfig, googleOAuthLogin, microsoftOAuthLogin} from "../../../api/index";
import {validateEmail} from "@/utils/validate";
import {ElButton} from "element-plus";
import {emailReg} from "@/utils/statusParams";
import {i18n} from "@/lang";

const initMail = localStorage.getItem("INITMAIL") || "";

const SMTP_587_TYPES = ["MicrosoftOut", "MicrosoftHot", "gmail"];

const MAIL_CONFIG_MAP = {
  jck: {
    config: [
      {host: "123.147.195.194", port: 465, protocol: "pop3", useWay: 1},
      {host: "123.147.195.194", port: 465, protocol: "smtp", useWay: 1},
      {host: "123.147.195.194", port: 993, protocol: "imap", useWay: 1},
    ],
    mailTypes: "jck",
  },
  tengXunQQ: {
    config: [
      {host: "pop.qq.com", port: 465, protocol: "pop3", useWay: 1},
      {host: "smtp.qq.com", port: 465, protocol: "smtp", useWay: 1},
      {host: "imap.qq.com", port: 993, protocol: "imap", useWay: 1},
    ],
    mailTypes: "tengXunQQ",
  },
  tengXunQiYe: {
    config: [
      {host: "pop.exmail.qq.com", port: 465, protocol: "pop3", useWay: 1},
      {host: "smtp.exmail.qq.com", port: 465, protocol: "smtp", useWay: 1},
      {host: "imap.exmail.qq.com", port: 993, protocol: "imap", useWay: 1},
    ],
    mailTypes: "tengXunQiYe",
  },
  wangYi: {
    config: [
      {host: "pop.163.com", port: 465, protocol: "pop3", useWay: 1},
      {host: "smtp.163.com", port: 465, protocol: "smtp", useWay: 1},
      {host: "imap.163.com", port: 993, protocol: "imap", useWay: 1},
    ],
    mailTypes: "wangYi",
  },
  wangYiQiYe: {
    config: [
      {host: "pop.qiye.163.com", port: 995, protocol: "pop3", useWay: 1},
      {host: "smtp.qiye.163.com", port: 465, protocol: "smtp", useWay: 1},
      {host: "imap.qiye.163.com", port: 993, protocol: "imap", useWay: 1},
    ],
    mailTypes: "wangYiQiYe",
  },
  "126": {
    config: [
      {host: "pop.126.com", port: 465, protocol: "pop3", useWay: 1},
      {host: "smtp.126.com", port: 465, protocol: "smtp", useWay: 1},
      {host: "imap.126.com", port: 993, protocol: "imap", useWay: 1},
    ],
    mailTypes: "126",
  },
  ali: {
    config: [
      {host: "pop.qiye.aliyun.com", port: 995, protocol: "pop3", useWay: 1},
      {host: "smtp.qiye.aliyun.com", port: 465, protocol: "smtp", useWay: 1},
      {host: "imap.qiye.aliyun.com", port: 993, protocol: "imap", useWay: 1},
    ],
    mailTypes: "ali",
  },
  "139": {
    config: [
      {host: "pop.139.com", port: 465, protocol: "pop3", useWay: 1},
      {host: "smtp.139.com", port: 465, protocol: "smtp", useWay: 1},
      {host: "imap.139.com", port: 993, protocol: "imap", useWay: 1},
    ],
    mailTypes: "139",
  },
  sina: {
    config: [
      {host: "pop.sina.com", port: 465, protocol: "pop3", useWay: 1},
      {host: "smtp.sina.com", port: 465, protocol: "smtp", useWay: 1},
      {host: "imap.sina.com", port: 993, protocol: "imap", useWay: 1},
    ],
    mailTypes: "sina",
  },
  souhu: {
    config: [
      {host: "pop.souhu.com", port: 465, protocol: "pop3", useWay: 1},
      {host: "smtp.souhu.com", port: 465, protocol: "smtp", useWay: 1},
      {host: "imap.souhu.com", port: 993, protocol: "imap", useWay: 1},
    ],
    mailTypes: "souhu",
  },
  "263": {
    config: [
      {host: "pop.263.net", port: 995, protocol: "pop3", useWay: 1},
      {host: "smtp.263.net", port: 465, protocol: "smtp", useWay: 1},
      {host: "imap.263.net", port: 993, protocol: "imap", useWay: 1},
    ],
    mailTypes: "souhu",
  },
  "189": {
    config: [
      {host: "pop.189.cn", port: 995, protocol: "pop3", useWay: 1},
      {host: "smtp.189.cn", port: 465, protocol: "smtp", useWay: 1},
      {host: "imap.189.cn", port: 993, protocol: "imap", useWay: 1},
    ],
    mailTypes: "189",
  },
  wo: {
    config: [
      {host: "pop.wo.com.cn", port: 995, protocol: "pop3", useWay: 1},
      {host: "smtp.wo.com.cn", port: 465, protocol: "smtp", useWay: 1},
      {host: "imap.wo.com.cn", port: 993, protocol: "imap", useWay: 1},
    ],
    mailTypes: "wo",
  },
  "88": {
    config: [
      {host: "pop.88.com", port: 995, protocol: "pop3", useWay: 1},
      {host: "smtp.88.com", port: 465, protocol: "smtp", useWay: 1},
      {host: "imap.88.com", port: 993, protocol: "imap", useWay: 1},
    ],
    mailTypes: "88",
  },
  MicrosoftOut: {
    config: [
      {host: "outlook.office365.com", port: 995, protocol: "pop3", useWay: 1},
      {host: "smtp-mail.outlook.com", port: 587, protocol: "smtp", useWay: 1},
      {host: "outlook.office365.com", port: 993, protocol: "imap", useWay: 1},
    ],
    mailTypes: "MicrosoftOut",
  },
  MicrosoftHot: {
    config: [
      {host: "outlook.office365.com", port: 995, protocol: "pop3", useWay: 1},
      {host: "smtp.office365.com", port: 587, protocol: "smtp", useWay: 1},
      {host: "outlook.office365.com", port: 993, protocol: "imap", useWay: 1},
    ],
    mailTypes: "MicrosoftHot",
  },
  gmail: {
    config: [
      {host: "pop.gmail.com", port: 995, protocol: "pop3", useWay: 1},
      {host: "smtp.gmail.com", port: 587, protocol: "smtp", useWay: 1},
      {host: "imap.gmail.com", port: 993, protocol: "imap", useWay: 1},
    ],
    mailTypes: "MicrosoftHot",
  },
};

const useWayOptions = [
  {label: i18n.global.t('use.way.options.open'), value: 1},
  {label: i18n.global.t('use.way.options.close'), value: 0},
];

export default {
  name: "mailLogin",
  props: {
    // [add, edit]
    actionMode: {
      type: String,
      default: "add",
    },
    initData: {
      type: Object,
      default: () => {
      },
    },
    // 账户类型
    initMailAccountType: {
      type: String,
      default: "other",
    },
    // 是否显示状态
    showUseWay: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      options: [
        {
          imgHeight: "12px",
          src: require("@/assets/img/mail/tx.png"),
          label: i18n.global.t('common.email.type.txyx'),
          value: "tengXunQiYe",
        },
        {
          imgHeight: "12px",
          src: require("@/assets/img/mail/qq.png"),
          label: i18n.global.t('common.email.type.qqyx'),
          value: "tengXunQQ",
        },
        {
          imgHeight: "12px",
          src: require("@/assets/img/mail/163.png"),
          label: i18n.global.t('common.email.type.163'),
          value: "wangYi",
        },
        {
          imgHeight: "12px",
          src: require("@/assets/img/mail/126.png"),
          label: i18n.global.t('common.email.type.126'),
          value: "126",
        },
        {
          imgHeight: "16px",
          src: require("@/assets/img/mail/ali.png"),
          label: i18n.global.t('common.email.type.ali'),
          value: "ali",
        },
        {
          imgHeight: "10px",
          src: require("@/assets/img/mail/139.png"),
          label: i18n.global.t('common.email.type.139'),
          value: "139",
        },
        {
          imgHeight: "12px",
          src: require("@/assets/img/mail/xinlang.png"),
          label: i18n.global.t('common.email.type.sina'),
          value: "sina",
        },
        {
          imgHeight: "12px",
          src: require("@/assets/img/mail/souhushandian.png"),
          label: i18n.global.t('common.email.type.souhu'),
          value: "souhu",
        },
        {
          imgHeight: "10px",
          src: require("@/assets/img/mail/189.png"),
          label: i18n.global.t('common.email.type.189'),
          value: "189",
        },
        {
          imgHeight: "10px",
          src: require("@/assets/img/mail/263.jpg"),
          label: i18n.global.t('common.email.type.263'),
          value: "263",
        },
        {
          imgHeight: "12px",
          src: require("@/assets/img/mail/mail.png"),
          label: i18n.global.t('common.email.type.other'),
          value: "other",
        },
      ],
      loginForm: {
        remark: "",
        username: "",
        password: "",
        account: "",
        mailType: "",
        useWay: 1,
        showPwd: false,
        // 接受协议（pop3/imap）
        acceptProtocol: "",
        acceptHost: "",
        acceptSsl: 0,
        sendSsl: 0,
        acceptPort: "",
        // 发送协议（SMTP）
        sendProtocol: "smtp",
        sendHost: "",
        sendPort: "",
      },
      useWayOptions: useWayOptions,
      mailConfigTypes: [
        {label: "POP3", value: "pop3"},
        {label: "IMAP", value: "imap"},
      ],
      checked: false,
      codeUrl: "",
      codeText: "",
      passwordType: "password",
      loading: false,
      mailConfigDialog: false,
      mailConfigForm: {},
      mailAccountType: "other",
      emailMap: {
        '@qq': 'tengXunQQ',
        'exmail.qq': 'tengXunQiYe',
        'qiye.163.com': 'wangYiQiYe',
        '@163.com': 'wangYi',
        '@126.com': '126',
        '@139.com': '139',
        'sina': 'sina',
        'souhu': 'souhu',
        '263': '263',
        '189': '189',
        'wo': 'wo',
        '88': '88',
        'outlook': 'MicrosoftOut',
        'hotmail': 'MicrosoftHot',
        'gmail': 'gmail',
        'aliyun': 'ali',
      },
      targetSelect: "",
      isFind: false,
      isUserInputAcceptPort: false,
      isUserInputSendPort: false,
    };
  },
  computed: {
    teamId() {
      return this.$store.state.email.teamID;
    },
    // 判断是否为 OAuth 模式（Google、Microsoft、Outlook）
    isOAuth() {
      const oauthTypes = ['google', 'microsoft', 'outlook'];
      const result = this.initData?.isOAuth === true || 
             oauthTypes.includes(this.mailAccountType) ||
             oauthTypes.includes(this.initData?.oauthType) ||
             oauthTypes.includes(this.initData?.mailType);
      
      console.log('isOAuth 计算属性:', {
        result,
        'initData.isOAuth': this.initData?.isOAuth,
        'mailAccountType': this.mailAccountType,
        'initData.oauthType': this.initData?.oauthType,
        'initData.mailType': this.initData?.mailType,
        'oauthTypes.includes(mailAccountType)': oauthTypes.includes(this.mailAccountType)
      });
      
      return result;
    },
    // 判断是否为 Google OAuth 模式（兼容旧代码）
    isGoogleOAuth() {
      const result = this.initData?.isGoogleOAuth === true || 
             this.mailAccountType === 'google' ||
             this.initData?.oauthType === 'google' ||
             this.initData?.mailType === 'google';
      
      console.log('isGoogleOAuth 计算属性:', {
        result,
        'mailAccountType': this.mailAccountType,
        'mailAccountType === google': this.mailAccountType === 'google'
      });
      
      return result;
    },
    formLabelWidth() {
      return this.isOAuth ? "auto" : "110px";
    },
    loginRules() {
      const baseRules = {
        username: [
          {required: true, message: i18n.global.t('mail.form.username'), trigger: "blur"},
          {pattern: emailReg, message: i18n.global.t('mail.form.username.reg'), trigger: ["blur", "change"]},
        ],
      };

      // Google OAuth 需要密码（应用专用密码）
      // Microsoft/Outlook OAuth 不需要密码
      // 其他邮箱都需要密码/授权码
      const needPassword = !this.isOAuth || this.isGoogleOAuth;
      
      if (needPassword) {
        const passwordMessage = this.isGoogleOAuth 
          ? i18n.global.t('auth.code.placeholder') // Google 使用授权码
          : (this.initMailAccountType === "tengXunQiYe" 
              ? i18n.global.t('40002') 
              : i18n.global.t('auth.code.placeholder'));
              
        baseRules.password = [
          {
            required: true,
            message: passwordMessage,
            trigger: "blur", // 只在失去焦点时触发，不在 change 时触发
          },
        ];
      }

      // 非 OAuth 模式需要服务器配置验证
      if (!this.isOAuth) {
        baseRules.acceptProtocol = [{
          required: true,
          message: i18n.global.t('common.please.select'),
          trigger: "blur" // 改为只在 blur 时触发
        }];
        baseRules.sendHost = [{required: true, message: i18n.global.t('mail.form.sendHost.reg'), trigger: "blur"}];
        baseRules.acceptHost = [{required: true, message: i18n.global.t('mail.form.acceptHost.reg'), trigger: "blur"}];
        baseRules.mailTypes = [
          {required: true, message: i18n.global.t('mail.form.mail.type.reg'), trigger: "blur"},
        ];
      }

      return baseRules;
    },
  },
  mounted() {
    console.log('mailLoginForm mounted:', {
      actionMode: this.actionMode,
      initData: this.initData,
      initMailAccountType: this.initMailAccountType,
      isOAuth: this.isOAuth,
      isGoogleOAuth: this.isGoogleOAuth
    });
    
    // 初始化数据
    if (this.actionMode === "edit") {
      console.log("edit", {...this.loginForm, ...this.initData})
      this.loginForm = {...this.loginForm, ...this.initData};
      
      // 编辑模式下，优先使用 oauthType，其次使用 mailType
      this.mailAccountType = this.loginForm.oauthType || this.loginForm.mailType;
      
      console.log('编辑模式 mailAccountType:', this.mailAccountType);
      
      // 编辑模式下，检查是否为 OAuth 类型
      const oauthTypes = ['google', 'microsoft', 'outlook'];
      if (oauthTypes.includes(this.mailAccountType)) {
        console.log('检测到 OAuth 类型，清除表单验证');
        // OAuth 模式：清除表单验证
        this.$nextTick(() => {
          setTimeout(() => {
            this.$refs.loginForm?.clearValidate?.();
          }, 0);
        });
        return;
      }
    } else {
      this.mailAccountType = this.initMailAccountType;
      this.loginForm.mailType = this.initMailAccountType;
      
      // OAuth 模式特殊处理
      if (this.isOAuth) {
        // OAuth 模式不需要初始化服务器配置
        // 延迟清除表单验证，确保在 loginRules 计算完成后执行
        this.$nextTick(() => {
          // 使用 setTimeout 确保在所有计算属性更新和 DOM 更新后执行
          setTimeout(() => {
            this.$refs.loginForm?.clearValidate?.();
          }, 0);
        });
        return;
      }
      
      // tengXunQiYe 显示默认后台的值
      this.loginForm.username =
          this.initMailAccountType === "tengXunQiYe" ? initMail : "";

      const hasPreset = this.initData && Object.keys(this.initData).length;
      if (hasPreset) {
        this.isUserInputAcceptPort = false;
        this.isUserInputSendPort = false;
        this.loginForm = {...this.loginForm, ...this.initData};

        if (this.initData.mailType) {
          this.mailAccountType = this.initData.mailType;
          this.loginForm.mailType = this.initData.mailType;
        }
      }

      this.initHostConfig();

      if (hasPreset && this.loginForm.acceptProtocol) {
        this.targetSelect = this.loginForm.acceptProtocol;
        this.selectChange(this.loginForm.acceptProtocol);
      }

      // 新增, jck不显示ssl
      if (this.mailAccountType === "jck") {
        this.loginForm.acceptSsl = 0;
        this.acceptPOP3SSLChange(false);
        this.acceptIMAPSSLChange(false);
        this.loginForm.sendSsl = 0;
        this.sendSMTPSSLChange(false);
      }
    }
    
    // 清除初始化时的表单验证错误提示
    // 使用 setTimeout 确保在所有计算属性更新和 DOM 更新后执行
    this.$nextTick(() => {
      setTimeout(() => {
        this.$refs.loginForm?.clearValidate?.();
      }, 0);
    });
  },
  watch: {
    mailAccountType(val) {
      this.initHostConfig();
    },
    "loginForm.sendHost": {
      handler(val) {
        this.handleHostOrSslChanged();
      },
    },
    "loginForm.acceptHost": {
      handler(val) {
        this.handleHostOrSslChanged();
      },
    },
  },
  methods: {
    // 获取密码字段的标签文本
    getPasswordLabel() {
      if (this.isGoogleOAuth) {
        return this.$t('app.password') + ':'; // Google 使用"应用密码"
      }
      
      const passwordTypes = ['tengXunQiYe', 'ali', '139', 'sina', 'souhu', '189', '263'];
      //if (passwordTypes.indexOf(this.mailAccountType) > -1) {
      //  return this.$t('common.password') + ':';
      //}
      
      return this.$t('auth.code') + ':';
    },
    
    // 获取密码字段的占位符文本
    getPasswordPlaceholder() {
      if (this.isGoogleOAuth) {
        return this.$t('app.password.placeholder'); // Google 使用应用密码提示
      }
      
      const passwordTypes = ['tengXunQiYe', 'ali', '139', 'sina', 'souhu', '189'];
      if (passwordTypes.indexOf(this.mailAccountType) > -1) {
        return this.$t('40002');
      }
      
      return this.$t('auth.code.placeholder');
    },
    
    // 打开 Google 应用密码页面
    openGoogleAppPasswordPage() {
      window.open('https://myaccount.google.com/apppasswords', '_blank');
    },
    
    onAcceptPortInput(value) {
      this.isUserInputAcceptPort = true;
      this.loginForm.acceptPort = value;
    },
    onSendPortInput(value) {
      this.isUserInputSendPort = true;
      this.loginForm.sendPort = value;
    },
    isSmtp587MailType() {
      return SMTP_587_TYPES.includes(this.mailAccountType);
    },
    handleHostOrSslChanged() {
      if (!this.isUserInputAcceptPort) {
        if (this.targetSelect === "pop3") {
          this.acceptPOP3SSLChange();
        } else if (this.targetSelect === "imap") {
          this.acceptIMAPSSLChange();
        }
      }
      if (!this.isUserInputSendPort) {
        this.sendSMTPSSLChange();
      }
    },
    //  选择邮箱
    checkTargetEmails(value) {
      const raw = typeof value === 'string' ? value : value?.target?.value;
      const target = (raw || '').toLowerCase().trim();

      if (!target) return;
      if (!emailReg.test(target)) return;
      
      // 企业邮箱类型列表：用户明确选择这些类型后，不应该再进行自动检测
      const enterpriseMailTypes = ['tengXunQiYe', 'wangYiQiYe', 'ali'];
      
      // 如果用户已经选择了企业邮箱类型，保持该类型不变
      if (enterpriseMailTypes.includes(this.initMailAccountType)) {
        this.isFind = true;
        this.$nextTick(() => {
          this.$refs.loginForm?.clearValidate?.([
            'acceptHost',
            'sendHost',
            'acceptProtocol',
            'username',
          ]);
        });
        return;
      }
      
      // 对于国际邮箱（Google、Microsoft、Outlook），不强制校验邮箱域名
      // 因为这些服务可能绑定了其他邮箱（如 QQ 邮箱）
      const isInternationalOAuth = ['google', 'microsoft', 'outlook'].includes(this.mailAccountType);
      
      if (isInternationalOAuth) {
        // 国际邮箱 OAuth 模式：不进行域名匹配，保持当前账户类型
        this.isFind = true;
        this.$nextTick(() => {
          this.$refs.loginForm?.clearValidate?.([
            'acceptHost',
            'sendHost',
            'acceptProtocol',
            'username',
          ]);
        });
        return;
      }
      
      // 对于非国际邮箱，进行正常的域名匹配
      const matched = Object.entries(this.emailMap).find(([key]) => target.includes(key));

      if (matched) {
        const matchedType = matched[1];
        this.mailAccountType = matchedType;
        this.loginForm.sendSsl = 1;
        this.loginForm.acceptSsl = 1;
        this.isUserInputAcceptPort = false;
        this.isUserInputSendPort = false;
        this.loginForm.sendPort = this.isSmtp587MailType() ? 587 : 465;
        this.loginForm.acceptPort = this.targetSelect === 'pop3' ? 995 : 993;
        this.isFind = true;

        this.$nextTick(() => {
          this.$refs.loginForm?.clearValidate?.([
            'acceptHost',
            'sendHost',
            'acceptProtocol',
            'username',
          ]);
        });
        return;
      }

      // 未识别到内置服务商：不要清空用户已输入的服务器/端口，避免误报校验错误
      this.mailAccountType = "other";
      this.isFind = false;
    },


    // 初始化host
    initHostConfig() {
      const mailAccountType = this.mailAccountType;
      const {acceptProtocol, sendProtocol} = this.loginForm;
      this.loginForm.acceptHost = this.getFormatMailConfig(
          mailAccountType,
          acceptProtocol
      ).host;
      this.loginForm.sendHost = this.getFormatMailConfig(
          mailAccountType,
          sendProtocol
      ).host;
    },
    showPassword() {
      this.passwordType === ""
          ? (this.passwordType = "password")
          : (this.passwordType = "");
    },
    // 选中item
    handleSelectItem(item) {
      this.mailConfigDialog = true;
    },
    // 获取转换参数
    getFormatMailConfig(mailType, protocol) {
      protocol = protocol.toLowerCase();
      const defaultResData = {
        config: [
          {host: "", port: 465, protocol: "pop3", useWay: 1},
          {host: "", port: 465, protocol: "smtp", useWay: 1},
          {host: "", port: 993, protocol: "imap", useWay: 1},
        ],
        mailTypes: "other",
      };

      const resData = MAIL_CONFIG_MAP[mailType] || defaultResData;
      const matched = resData.config.find((item) => item.protocol === protocol);
      if (matched) return matched;
      return resData;
    },
    cancels() {
      this.$emit("success");
    },
    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          
          // OAuth 模式使用专用接口
          if (this.isOAuth) {
            // 根据不同的 OAuth 类型选择不同的接口
            let oauthApi;
            // 优先使用 initData 中的 oauthType，其次使用 mailAccountType
            let oauthType = this.initData?.oauthType || this.mailAccountType;
            
            console.log('OAuth 类型判断:', {
              'initData.oauthType': this.initData?.oauthType,
              'mailAccountType': this.mailAccountType,
              'initData.isGoogleOAuth': this.initData?.isGoogleOAuth,
              '最终使用的 oauthType': oauthType
            });
            
            // 兼容旧的 isGoogleOAuth 标记
            if (this.initData?.isGoogleOAuth || oauthType === 'google') {
              oauthApi = googleOAuthLogin;
              oauthType = 'google'; // 统一类型名称
            } else if (oauthType === 'microsoft' || oauthType === 'outlook') {
              // Microsoft 和 Outlook 使用同一个接口
              oauthApi = microsoftOAuthLogin;
            } else {
              console.error('不支持的 OAuth 类型，详细信息:', {
                oauthType,
                mailAccountType: this.mailAccountType,
                initData: this.initData
              });
              this.$message.error('不支持的 OAuth 类型: ' + oauthType);
              this.loading = false;
              return;
            }
            
            // 构建请求数据
            const data = {
              teamId: this.teamId,
              username: this.loginForm.username,
              remark: this.loginForm.remark || '',
            };
            
            // Google 需要传递应用密码
            if (oauthType === 'google') {
              data.password = this.loginForm.password;
            }
            
            console.log(`${oauthType} OAuth data:`, data);
            oauthApi(data)
                .then((res) => {
                  console.log(`${oauthType} OAuth response:`, res);
                  
                  // 成功：在新标签页打开 OAuth 认证 URL
                  const oauthUrl = res.message || res.result;
                  if (oauthUrl) {
                    window.open(oauthUrl, '_blank');
                    this.$emit("success");
                  } else {
                    console.error(`${oauthType} OAuth response missing URL:`, res);
                  }
                })
                .catch((error) => {
                  console.error(`${oauthType} OAuth error:`, error);
                  
                  // 根据响应拦截器的逻辑，code 500 时会 reject(message)
                  // 所以 error 可能是字符串（message）或者对象
                  let errorMsg = i18n.global.t('sys.message.error');
                  
                  if (typeof error === 'string') {
                    // 直接是错误消息字符串
                    errorMsg = error;
                  } else if (error?.response?.data?.message) {
                    // 标准错误响应格式
                    errorMsg = error.response.data.message;
                  } else if (error?.data?.message) {
                    // 简化的错误响应格式
                    errorMsg = error.data.message;
                  } else if (error?.message) {
                    // 错误对象的 message 属性
                    errorMsg = error.message;
                  }
                  
                  console.error(`${oauthType} OAuth request failed:`, errorMsg);
                })
                .finally(() => {
                  this.loading = false;
                });
            return;
          }
          
          // 标准邮箱配置流程
          const mailType = this.loginForm.mailTypes;
          const mailAccountType = this.mailAccountType;
          const {acceptProtocol, sendProtocol} = this.loginForm;
          const data = {
            ...this.loginForm,
            acceptPort: this.loginForm.acceptPort * 1,
            sendPort: this.loginForm.sendPort * 1,
            mailTypes: mailType,
            teamId: this.teamId,
            username: this.loginForm.username,
            password: this.loginForm.password,
          };
          console.log(data, 'data');
          const requestApi = this.actionMode === 'add' ? setMailConfigList : updateConfig;
          const successText =
              this.actionMode === "add" ? i18n.global.t('sys.message.success.add') : i18n.global.t('sys.message.success.update');
          requestApi(data)
              .then((res) => {
                if (res.code === 200) {
                  this.$message.success(successText);
                  this.$emit("success");
                }
              })
              .finally(() => {
                this.loading = false;
              });
        } else {
          return false;
        }
      });
    },
    handleMailConfigDialogCancel() {
      this.mailConfigDialog = false;
    },
    selectChange(value) {
      this.targetSelect = value
      const isGmail = this.mailAccountType === 'gmail'
      if (isGmail) {
        this.loginForm.acceptSsl = 1;
        this.loginForm.sendSsl = 1;
      }
      if (value === "pop3") {
        this.acceptPOP3SSLChange();
      } else if (value === "imap") {
        this.acceptIMAPSSLChange();
      }
      this.sendSMTPSSLChange();
      this.initHostConfig();
    },
    // POP3 ssl
    acceptPOP3SSLChange(value) {
      if (this.loginForm.acceptHost) {
        this.loginForm.acceptPort = this.loginForm.acceptSsl === 1 ? 995 : 110;
      } else {
        this.loginForm.acceptPort = ""
      }
    },
    // IMAP ssl
    acceptIMAPSSLChange(value) {
      if (this.loginForm.acceptHost) {
        this.loginForm.acceptPort = this.loginForm.acceptSsl === 1 ? 993 : 143;
      } else {
        this.loginForm.acceptPort = ""
      }
    },
    // SMTP ssl
    sendSMTPSSLChange(value) {
      if (this.loginForm.sendHost) {
        if (this.mailAccountType === 'wangYiQiYe') {
          this.loginForm.sendPort = this.loginForm.sendSsl === 1 ? 465 : 25;
          return;
        }
        if (this.isSmtp587MailType()) {
          this.loginForm.sendPort = this.loginForm.sendSsl === 1 ? 587 : 25;
        } else {
          this.loginForm.sendPort = this.loginForm.sendSsl === 1 ? 465 : 25;
        }

      } else {
        this.loginForm.sendPort = "";
      }
    },
  },
  components: {ElButton},
};
</script>

<style lang="less" scoped>
.login-form {
  margin: 10px 0;
  font-size: 13px;

  i {
    color: #333;
  }

  .el-form-item__content {
    width: 100%;
  }

  :deep(.el-form-item__content) {
    //justify-content: space-between !important;
  }

  .el-form-item {
    margin-bottom: 12px;
  }

  .mail-server-row {
    :deep(.el-form-item__content) {
      display: flex;
      align-items: center;
      flex-wrap: nowrap;
    }
  }

  .mail-server-row__port-label {
    display: inline-block;
    width: 44px;
    text-align: right;
    margin-right: 12px;
    flex: 0 0 auto;
  }

  .mail-server-row__port-input {
    flex: 0 0 auto;
  }

  .el-input {
    input {
      padding-bottom: 6px;
      text-indent: 5px;
      font-size: 13px;
      background: transparent;
      border: none;
      border-radius: 0;
      color: #333;
      border-bottom: 1px solid rgb(235, 237, 242);
    }

    .el-input__prefix {
      i {
        padding: 0 5px;
        font-size: 16px !important;
      }
    }
  }
}

.login-form--oauth {
  max-width: 460px;
  margin: 10px auto 0;
}

.login-form-small {
  :deep(.el-input--mini .el-input__inner) {
    height: 26px !important;
    line-height: 26px !important;
    font-size: 13px;
  }

  :deep(.el-select .el-input__inner) {
    height: 26px !important;
    line-height: 26px !important;
    font-size: 13px;
  }
}

.login-form .el-form-item {
  margin-bottom: 20px !important;
}

.flex_end {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
  //margin-bottom: -15px;
  margin-right: 10px;
}

:deep(.el-form-item__label) {
  font-size: 13px;
  font-weight: 500 !important;
}

:deep(.el-form-item__content) {
  font-size: 13px;
  flex-wrap: nowrap !important;
}

:deep(.el-checkbox__label) {
  font-size: 13px;
}

:deep(.el-button) {
  font-size: 13px;
}
:deep(.el-select__wrapper){
  min-height:28px !important;
}
</style>
